/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.campaignsbucket.rpc.CampaignsBucketServiceFrontendRpc
 */

export const resolveBucketsRpc = {
  serviceName: 'com.hubspot.campaignsbucket.rpc.CampaignsBucketServiceFrontendRpc',
  rpcName: 'resolveBuckets',
  auth: 'app',
  fingerprint: 'WfgGZOhAlfifKjtHGszjeaz7aBjS-F1s',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const resolveBucketsByAssetCoordinatesRpc = {
  serviceName: 'com.hubspot.campaignsbucket.rpc.CampaignsBucketServiceFrontendRpc',
  rpcName: 'resolveBucketsByAssetCoordinates',
  auth: 'app',
  fingerprint: 'dnql6da_3dGfKjtHGszjeaz7aBjS-F1s',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const resolveBucketsWithUtmRpc = {
  serviceName: 'com.hubspot.campaignsbucket.rpc.CampaignsBucketServiceFrontendRpc',
  rpcName: 'resolveBucketsWithUtm',
  auth: 'app',
  fingerprint: 'WfgGZOhAlfhLmheEtc90k6z7aBjS-F1s',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const resolveBucketsWithUtmByAssetCoordinatesRpc = {
  serviceName: 'com.hubspot.campaignsbucket.rpc.CampaignsBucketServiceFrontendRpc',
  rpcName: 'resolveBucketsWithUtmByAssetCoordinates',
  auth: 'app',
  fingerprint: 'dnql6da_3dFLmheEtc90k6z7aBjS-F1s',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};